import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchInsightsStart,
    fetchInsightsSuccess,
    fetchInsightsFailure,
    loadInsightsRequest,
} from '../insightsSlice';
import { getInsightsApi } from '../../api/apiLists/getInsightsApi';
import { showLoader, hideLoader } from '../loaderSlice';
import { callWithAuth } from '../sagaApiHelper';

function* handleFetchInsights(action) {
    const { key, startTime, endTime } = action.payload;

    try {
        yield put(showLoader());
        yield put(fetchInsightsStart(key));
        const res = yield call(callWithAuth, getInsightsApi, [key, startTime, endTime]);

        if (res.status) {
            yield put(fetchInsightsSuccess({ key, data: res.data }));
        } else {
            yield put(fetchInsightsFailure({ key, error: res.errMsg }));
        }
    } catch (error) {
        yield put(fetchInsightsFailure({ key, error: error.message }));
    } finally {
        yield put(hideLoader());
    }
}

function* insightsSaga() {
    yield takeLatest(loadInsightsRequest.type, handleFetchInsights);
}

export default insightsSaga;
